import React, { useState, useMemo, useEffect } from "react"
import { Row, Col, Card, Table } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import NewPagination from "components/Common/Newpagination"
import { fetchNodeData } from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import secureLocalStorage from "react-secure-storage"
import { TodaysTaskColumns } from "utils/columns/ElementsColumns/developmentColumns"
import { calculateCompleteTime } from "utils/common-helpers"

function TableContainer({
  columns,
  data,
  selectedDate,
  setSelectedDate,
  allData,
  setData,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [{ id: "timer_id", desc: true }],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  const [type, setType] = useState("1")

  useEffect(() => {
    setPageSize(10)
  }, [])

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2">
              <div className="mb-3 text-purple fs-5 fw-bold d-flex gap-2">
                {" "}
                My Today's Tasks
                <a
                  className={`d-flex gap-3 align-items-center general-box ${
                    type == "1" ? "bg-purple" : ""
                  } `}
                  onClick={() => {
                    setData(
                      allData?.filter(obj => obj?.task_type == "project_task")
                    )
                    setType("1")
                  }}
                >
                  <h5 className="text-purple mb-0">Task : </h5>
                  <h5 className="text-primary mb-0">
                    {
                      allData?.filter(obj => obj?.task_type == "project_task")
                        ?.length
                    }
                  </h5>
                </a>
                <a
                  className={`d-flex gap-3 align-items-center general-box  ${
                    type == "2" ? "bg-purple" : ""
                  }`}
                  onClick={() => {
                    setData(
                      allData?.filter(obj => obj?.task_type == "support_ticket")
                    )
                    setType("2")
                  }}
                >
                  <h5 className="text-purple mb-0">Support : </h5>
                  <h5 className="text-primary mb-0">
                    {
                      allData?.filter(obj => obj?.task_type == "support_ticket")
                        ?.length
                    }
                  </h5>
                </a>
                <a
                  className={`d-flex gap-3 align-items-center general-box  ${
                    type == "3" ? "bg-purple" : ""
                  }`}
                  onClick={() => {
                    setData(
                      allData?.filter(obj => obj?.task_type == "code_review")
                    )
                    setType("3")
                  }}
                >
                  <h5 className="text-purple mb-0">Code Review : </h5>
                  <h5 className="text-primary mb-0">
                    {
                      allData?.filter(obj => obj?.task_type == "code_review")
                        ?.length
                    }
                  </h5>
                </a>
                <a className="d-flex gap-3 align-items-center general-box  ">
                  <h5 className="text-purple mb-0">Total Today's Time : </h5>
                  <h5 className="text-primary mb-0">
                    {calculateCompleteTime(allData, "total_time_spent")}
                  </h5>
                </a>
              </div>

              <div className="flex-grow-1 d-flex justify-content-end mr-2">
                <div className="col-auto">
                  <input
                    type="date"
                    className="form-control "
                    value={selectedDate}
                    onChange={e => setSelectedDate(e.target.value)}
                  />
                </div>
                <div className="col-2 cusrtom_search_box ">
                  <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100 ms-2 ">
                    <div className="position-relative w-100">
                      <input
                        onChange={e => setGlobalFilter(e.target.value)}
                        type="text"
                        className=" form-control h-100 w-100"
                        placeholder="Search..."
                        value={globalFilter || ""}
                      />
                      <i className="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead className="fixed_view_payment_table">
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={`t-col-${index + 1} ${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          {column.render("Header")}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row, i) => {
                    prepareRow(row)
                    return (
                      <tr key={i} {...row.getRowProps()}>
                        {row.cells.map((cell, index) => (
                          <td key={index} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
            <Row className="justify-content-md-end justify-content-center align-items-center">
              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  )
}

const DevTodaysTask = () => {
  const [data, setData] = useState([])
  const [allData, setAllData] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  )

  const toggleLoading = loading => {
    setLoading(loading)
  }

  const GetData = async (dateParam = selectedDate) => {
    const res = await fetchNodeData(
      toggleLoading,
      `todaysTasks/${localStorage.getItem("auth_id")}/${dateParam}`,
      secureLocalStorage.getItem("auth_token")
    )

    if (res && res.status) {
      setData(res.tasks?.filter(obj => obj?.task_type == "project_task") || [])
      setAllData(res.tasks || [])
    } else {
      setData([])
    }
  }

  useEffect(() => {
    GetData(selectedDate)
  }, [selectedDate])

  const columns = useMemo(() => TodaysTaskColumns(), [])

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <Row>
        <Col lg="12">
          <Card>
            <div className="responsive-table">
              <TableContainer
                columns={columns}
                data={data}
                allData={allData}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                setData={setData}
              />
            </div>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default DevTodaysTask
